module.exports = __webpack_public_path__ + "Icon_Users Managements.2790d6afd98921afac3a.png";